import React from "react";

export const TwitterIcon = ({
  width = "20.529",
  height = "16.68",
  fill = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.529 16.68"
      {...{ fill, width, height }}
    >
      <path
        id="Forma_1"
        data-name="Forma 1"
        d="M1315.789,5652.46a8.812,8.812,0,0,1-2.425.665,4.186,4.186,0,0,0,1.852-2.326,8.409,8.409,0,0,1-2.669,1.019,4.208,4.208,0,0,0-7.28,2.878,4.337,4.337,0,0,0,.1.959,11.911,11.911,0,0,1-8.675-4.4,4.211,4.211,0,0,0,1.293,5.625,4.162,4.162,0,0,1-1.9-.519v.046a4.229,4.229,0,0,0,3.372,4.136,4.218,4.218,0,0,1-1.1.138,3.739,3.739,0,0,1-.8-.071,4.249,4.249,0,0,0,3.932,2.931,8.456,8.456,0,0,1-5.218,1.795,7.86,7.86,0,0,1-1.007-.058,11.979,11.979,0,0,0,18.435-10.087c0-.186-.006-.365-.016-.543A8.411,8.411,0,0,0,1315.789,5652.46Z"
        transform="translate(-1295.26 -5650.485)"
      />
    </svg>
  );
};
